import { render, staticRenderFns } from "./EditTemplateDialog.vue?vue&type=template&id=4be519a0"
import script from "./EditTemplateDialog.vue?vue&type=script&lang=js"
export * from "./EditTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./EditTemplateDialog.vue?vue&type=style&index=0&id=4be519a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports